import React, { useEffect, useState } from "react";
import { useI18n } from "@/contexts/I18nContext";

/**
 * Batch 9 · A2 / A16 — a loading line that counts the seconds and, after a few, says the server is busy, so a page under load
 * never looks blank or empty ("No head folders yet" while the list was still loading). en + ar.
 */
const T = {
  en: { loading: "Loading…", slow: (s) => `Still loading (${s} s) — the server is busy with another task; the page fills in as soon as it answers.`, since: (s) => `${s} s` },
  ar: { loading: "جارٍ التحميل…", slow: (s) => `ما زال التحميل جاريًا (${s} ث) — الخادم مشغول بمهمة أخرى؛ تمتلئ الصفحة بمجرد الرد.`, since: (s) => `${s} ث` },
};

export function useElapsed(active) {
  const [s, setS] = useState(0);
  useEffect(() => {
    if (!active) { setS(0); return undefined; }
    const t0 = Date.now();
    const id = setInterval(() => setS(Math.round((Date.now() - t0) / 1000)), 1000);
    return () => clearInterval(id);
  }, [active]);
  return s;
}

export default function LoadingNote({ active = true, what = "", slowAfter = 5, className = "", "data-testid": testid }) {
  const { lang } = useI18n();
  const d = T[lang === "ar" ? "ar" : "en"];
  const s = useElapsed(active);
  if (!active) return null;
  return (
    <div className={`flex items-center gap-2 text-sm text-muted-foreground ${className}`} data-testid={testid || "loading-note"} role="status" aria-live="polite">
      <span className="inline-block h-3 w-3 animate-spin rounded-full border-2 border-slate-300 border-t-slate-700" />
      <span>{s >= slowAfter ? d.slow(s) : `${d.loading}${what ? ` ${what}` : ""}${s > 1 ? ` (${d.since(s)})` : ""}`}</span>
    </div>
  );
}
